import { Package2, Shield, Smartphone } from "lucide-react";
import { useTranslation } from "react-i18next";

export function IncludedItems() {
  const { t } = useTranslation();

  return (
    <div className="space-y-3">
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2">
          <Shield className="h-4 w-4" />
          <span className="text-sm font-normal">
            {t("includedItems.insurance")}
          </span>
        </div>
        <span className="text-sm font-bold">{t("includedItems.included")}</span>
      </div>
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2">
          <Smartphone className="h-4 w-4" />
          <span className="text-sm font-normal">
            {t("includedItems.screenProtector")}
          </span>
        </div>
        <span className="text-sm font-bold">{t("includedItems.included")}</span>
      </div>
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2">
          <Package2 className="h-4 w-4" />
          <span className="text-sm font-normal">
            {t("includedItems.clearCase")}
          </span>
        </div>
        <span className="text-sm font-bold">{t("includedItems.included")}</span>
      </div>
    </div>
  );
}
